import useGetMenuData from './useGetMenuData'
export default useGetMenuData
